import React from 'react';
import { CheckCircle } from 'react-feather';

const ApplySuccessModal = ({ show, handleClose, message }) => {
  return (
    <div 
      className={`modal fade ${show ? 'show d-block' : ''}`} 
      tabIndex="-1" 
      role="dialog"
      style={{ 
        backgroundColor: 'rgba(15, 23, 42, 0.8)', 
        backdropFilter: 'blur(8px)', 
        zIndex: 1100,
        transition: 'all 0.3s ease-in-out'
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-2xl rounded-4 overflow-hidden" style={{ animation: 'modalSlideUp 0.4s ease-out' }}>
          <div className="modal-body p-5 text-center">
            <div className="success-icon-wrapper mb-4 d-inline-flex align-items-center justify-content-center" style={{ 
              width: '100px', 
              height: '100px', 
              borderRadius: '50%', 
              backgroundColor: 'rgba(20, 160, 119, 0.1)',
              color: '#14A077'
            }}>
              <CheckCircle size={60} strokeWidth={1.5} />
            </div>
            <h2 className="fw-bold mb-4" style={{ color: '#14A077' }}>Başvurunuz Başarıyla Alındı</h2>
            <p className="text-secondary mb-5 px-3" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
              Yayıncı başvuru formunuz sistemimize kaydedilmiştir. Değerlendirme sürecinin ardından en kısa sürede sizinle iletişime geçeceğiz. İdealonline’a gösterdiğiniz ilgi için teşekkür ederiz.
            </p>
            <div className="d-grid gap-2 col-10 mx-auto">
              <button 
                type="button" 
                className="btn btn-lg px-5 py-3 rounded-pill fw-bold text-white shadow-lg transition-all" 
                style={{ 
                  backgroundColor: '#14A077', 
                  border: 'none',
                  fontSize: '1rem',
                  letterSpacing: '0.5px'
                }}
                onClick={handleClose}
              >
                Ana Sayfaya Git
              </button>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes modalSlideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .transition-all {
          transition: all 0.2s ease-in-out;
        }
        .transition-all:hover {
          transform: translateY(-2px);
          filter: brightness(1.1);
          box-shadow: 0 10px 20px rgba(20, 160, 119, 0.2) !important;
        }
      `}</style>
    </div>
  );
};

export default ApplySuccessModal;
